<script lang="ts">
  import type { ClosingState } from '@pin/schemas/client-state-response';
  import { format } from 'date-fns';
  import { onMount } from 'svelte';
  import Receipt from '../components/Receipt.svelte';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';
  import { getItem } from '../util/storage';
  import { getSubmittedVotesKey } from '../util/votesKeys';
  export let pollData: ClosingState;

  $: closeTime = format(new Date(pollData.endTime), "' kl. 'HH:mm");

  $: votes = getItem<string[]>('local', getSubmittedVotesKey(pollData.id));
  onMount(() => {
    trackEvent(
      { action: 'state:closed-poll', label: pollData.title },
      pollData.id
    );
  });
</script>

{#if votes}
  <!-- svelte-ignore a11y-autofocus -->
  <h2 autofocus tabindex="-1">{i18n('poll.thanks-for-vote')}</h2>
  <p>{i18n('poll.closed', { values: { closeTime } })}</p>
{:else}
  <!-- svelte-ignore a11y-autofocus -->
  <h2 autofocus tabindex="-1">
    {i18n('poll.closed', { values: { closeTime } })}
  </h2>
{/if}
{#if votes}
  <Receipt alternatives={pollData.alternatives} {votes} />
{/if}
